/* eslint-disable react/prop-types */
import React from 'react';
import { LocalizationProvider, DatePicker } from '@mui/lab';
import DateAdapter from '@mui/lab/AdapterDateFns';
import enLocale from 'date-fns/locale/en-US';
import itLocale from 'date-fns/locale/it';
import TextField from '@mui/material/TextField';

const localeMap = {
  en: enLocale,
  it: itLocale,
};

const LocalizedDate = function LocalizedDate({ label, value, onChange, readOnly, variant, renderInput }) {
  return (
    <LocalizationProvider dateAdapter={DateAdapter} locale={localeMap[navigator.language.substring(0, 2)]}>
      <DatePicker
        label={label}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        disableOpenPicker={readOnly}
        // eslint-disable-next-line react/jsx-props-no-spreading
        renderInput={(params) => renderInput || <TextField {...params} variant={variant || 'outlined'} size="small" />}
      />
    </LocalizationProvider>
  );
};

export default LocalizedDate;
